import { useEffect, useState, useRef } from 'react'
import { Modal, Table, Space, Button, Dropdown, MenuProps, Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table';
import { CloseOutlined, } from '@ant-design/icons';
import style from './index.module.scss'
import { center } from '@antv/x6/lib/registry/node-anchor/bbox';
import { getUserList } from '../../api/user'
import * as apis from '../../api/networkDisk'

import user_default from '../../static/image/user_default.png'
import { getImgUrlById, deepCopy } from '../../util'
import useStore from '../../store/useStore'
import { memosModule } from '../../modules/memos'
import ManList from '../../components/talk/manList'
import { StorageModule } from '../../modules/storage'

interface Props {
    visible: any
    onClose: () => void;
    onRefresh: () => void;
    title: any;
}
interface DataType {
    key: React.Key;
    name: string;
}

const Talk = (props: Props) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [disabled, setDisabled] = useState<boolean>(true);
    const [data, setData] = useState<any>();
    const { store, dispatch } = useStore();
    const [userInfo, setUserInfo] = useState<any>( StorageModule.getUser().user);
    const columns: ColumnsType<DataType> = [
        {
            title: 'tx',
            dataIndex: 'avatar',
            key: 'avatar',
            colSpan: 0,
            render: (text: string, record: any) => <span>
                <>{console.log(record.id,store.onLine)}</>
                {
                    text ?
                        <img alt=""  className={`${style.user_default} ${store.onLine?.some((j:any)=>j===record.id)?'online':''}`} src={getImgUrlById(text)} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />

                        :
                        <img alt=""  className={`${style.user_default} ${store.onLine?.some((j:any)=>j===record.id)?'online':''}`}  src={user_default} />
                }
            </span>,
        },
        {
            title: '未受邀用户',
            align: 'left',
            key: 'username',
            dataIndex: 'username',
            colSpan: 2,
            render: (text: string) => <span>
                {text}</span>,
        },

        {
            title: '操作',
            key: 'action',
            width: 100,
            align: 'center',
            render: (_, record: any) => (
                <Space size="middle">
                    <a onClick={() => {
                        // let item: any = record
                        // let params: any = deepCopy(store.subjectInfo.data)
                        // params.$operate$ = 'save'
                        // params.users = params.users.concat([item.id])
                        // saveSubject(params)
                        operationMan([record?.id], 'add')
                        props.onClose()
                    }}>邀请</a>
                </Space>
            ),
        },
    ];
    const operationMan = (users: any, type: any) => {
        reset()
        memosModule.operationMan(users, type, store.subjectInfo.data)
    }
    useEffect(() => {
        if (!props.visible) {
            setTimeout(() => {
                reset()
            }, 200);
        } else { getList() }
    }, [props.visible])
    useEffect(() => {
        if (props.visible) {
            getList()
        }
    }, [store.subjectInfo?.data?.users])

    const getList = async () => {
        try {
            let res: any = await apis.topicUser()
            if (res.ok) {
                let arr = res.data.list.filter((item: any, index: any) => {
                    return store.subjectInfo.data.users.filter((i: any) => item.id === i).length === 0&&
                    store.subjectInfo.data.owner.id!==item.id;
                });
                setData(arr)
            }
        } catch (e) { }
    }

    /**
  * @name 重置
  */
    const reset = () => {
        setSelectedRowKeys([])

    }
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[],) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            // console.log(`onSelectNone:${onSelectNone}`)
            setSelectedRowKeys(selectedRowKeys)
            selectedRowKeys?.length > 0 ? setDisabled(false) : setDisabled(true)

        },

        getCheckboxProps: (record: DataType) => ({
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name,
        }),
    };

    return (
        <Modal
            centered
            footer={null}
            // closable={false}
            onCancel={() => {
                props.onClose()
            }}
            width={'700px'}

            title={props.title}
            open={props.visible}>
            <div data-flex='main:center;cross:center' className='mt-20'>
                <div className='mr-20 wp-55'  >
                    <div style={{ height: "400px" }}>

                        <Table
                            rowSelection={{
                                type: 'checkbox',
                                ...rowSelection,
                            }}
                            scroll={{ y: 300 }}
                            rowKey="id"
                            pagination={false}
                            columns={columns}
                            dataSource={data}
                        />
                    </div>

                    <div data-flex='main:justify' className='mt-20'>
                        <div> {selectedRowKeys?.length > 0 && <div dangerouslySetInnerHTML={{
                            __html: `已选:<a>${selectedRowKeys?.length}</a>`
                        }}
                        />}</div>
                        <Button type="primary" key="look" disabled={selectedRowKeys?.length == 0} onClick={(e) => {
                            e.stopPropagation();
                            operationMan(selectedRowKeys, 'add')
                        }} >
                            确认添加
                        </Button>
                    </div>

                </div>
                <div className='wp-45'>
                    <div style={{ height: "400px",}}>
                        <div className={style.title}>讨论组({store.subjectInfo.data?.userInfos?.length}人)</div>
                        <div style={{ height: "350px",overflow:'auto'}}>
                        <ManList  isShowName={true} isWap={true} data={store.subjectInfo.data} />
                        </div>
                    </div>
                    <div data-flex='main:right' className='mt-20'>
                        {store.subjectInfo.data?.userInfos?.length > 0 &&
                            <Popconfirm
                                placement="leftBottom"
                                title={'确认解散讨论组？'}
                                onConfirm={(e: any) => {
                                    e.stopPropagation();
                                    operationMan([], 'deleteAll')
                                }}
                                okText="确认"
                                cancelText="取消"
                            >
                                {userInfo?.id===store.subjectInfo.data?.owner?.id&&<Button type="primary" key="look" danger  >

                                    解散讨论组
                                </Button>}
                            </Popconfirm>

                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default Talk